import { RootState } from '../../interfaces/rootState';

export const ToastStatusSelector = ({ toastStatus }: RootState) => toastStatus;
